
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import WxHeader from './Header'
import WxFooter from './Footer'

export default{
name:'MemberCenter',
components:{
Group,
Cell,
Flexbox,
FlexboxItem,
WxHeader,
WxFooter
},
data () {
return {
show_member_img : true,
member_img: 'image/icon/icon_fk.png',
true_member_img : '',
account : '',
nopayed_amount : 0,

}
},
created(){

let login_data = this.get_login_session_data();

if(!!login_data){
if(!!login_data.headimgurl){
this.show_member_img = false;
this.true_member_img = login_data.headimgurl;
}
if(!!login_data.account){
this.account = login_data.account;
}else{
this.account = login_data.nickname;
}
}
this.getNopayedAmount();
},
methods: {
user_account_logout(){
this.clear_login_session_data();

this.baseShowModuleAuto('登出成功，即将关闭页面','请稍后。。。');
setTimeout(() => {
window.opener=null;
window.open('','_self');
window.close();
WeixinJSBridge.call('closeWindow');
}, 3000)
},
getNopayedAmount(){
let _self = this;
let api_url = this.server_api_url+'service=get_member_nopayed_amount';
let formData = {};
let login_data = this.get_login_session_data();
let access_token = this.get_access_token();
if(login_data && access_token){
formData.openid = login_data.openid;
formData.member_id = login_data.member_id;
formData.YZICode_cur = login_data.YZICode_cur;
formData.house_id = login_data.house_id;
}else{
this.$router.push({path: MemberCenterUrl});
return false;
}
formData = this.qs.stringify(formData);
this.$axios({
method:'post',
url:api_url,
headers: {'token': access_token},
data:formData,

}).then((response) =>{
let data_arr = response.data;
_self.check_token_data_status(data_arr);
if(data_arr.status == '1'){
_self.nopayed_amount = data_arr.data.nopayed_amount;
}
}).catch((response) =>{
console.log(response)
})
},
}

}





// WEBPACK FOOTER //
// ./src/components/MemberCenter.vue